module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_update-82f5fa49598ef803ffb7b815c85e2ec9.svg";